/**
 * @generated SignedSource<<dbc46db8bcaeeb57e2d07e657422838e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Page_SlugP_portfolioProject$data = {
  readonly id: string;
  readonly publishedAt: ContraAPIScalars.DateTime | null;
  readonly title: string;
  readonly userProfile: {
    readonly displayUsername: string;
    readonly firstName: string | null;
    readonly id: string;
    readonly lastName: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"MoreProjectsCardList_portfolioProjects" | "NewProfileSidebar_userProfile" | "Project_userProfile">;
  };
  readonly visitorCanEdit: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"PortfolioProjectAdminActions_portfolioProject" | "Project_portfolioProject">;
  readonly " $fragmentType": "Page_SlugP_portfolioProject";
};
export type Page_SlugP_portfolioProject$key = {
  readonly " $data"?: Page_SlugP_portfolioProject$data;
  readonly " $fragmentSpreads": FragmentRefs<"Page_SlugP_portfolioProject">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Page_SlugP_portfolioProject",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "publishedAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "visitorCanEdit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUsername",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastName",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "NewProfileSidebar_userProfile"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "MoreProjectsCardList_portfolioProjects"
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Project_userProfile"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Project_portfolioProject"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PortfolioProjectAdminActions_portfolioProject"
    }
  ],
  "type": "PortfolioProject",
  "abstractKey": null
};
})();

(node as any).hash = "3657f8a819945e8f33329e81525576ef";

export default node;
